// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Глобальные стили для виджета amoCRM (внедряемый JS) */

/* Стили для внедряемого виджета */
.widget-container {
  position: relative;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* Сброс стилей только для элементов виджета */
.widget-container * {
  box-sizing: border-box;
}

/* Стили для корректной работы Layout внутри amoCRM */
.widget-container .ant-layout {
  background: transparent;
  min-height: auto;
}

.widget-container .ant-layout-content {
  padding: 0;
  background: transparent;
  min-height: auto;
} `, "",{"version":3,"sources":["webpack://./src/widget-styles.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD,kCAAkC;AAClC;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":["/* Глобальные стили для виджета amoCRM (внедряемый JS) */\n\n/* Стили для внедряемого виджета */\n.widget-container {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Сброс стилей только для элементов виджета */\n.widget-container * {\n  box-sizing: border-box;\n}\n\n/* Стили для корректной работы Layout внутри amoCRM */\n.widget-container .ant-layout {\n  background: transparent;\n  min-height: auto;\n}\n\n.widget-container .ant-layout-content {\n  padding: 0;\n  background: transparent;\n  min-height: auto;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
